import {
    Box, Table, TableBody, TableContainer, TableRow, TableHead, Paper, TableCell
} from '@mui/material';

/**
 * Dynamic TotalTable component for both Electricity Purchased and Renewable Energy Produced totals.
 *
 * Props:
 * - dataTotals: array of totals data (required)
 * - columns: array of { label, field } for table columns (required)
 * - grandTotalFields: array of { field, label } for grand total row (optional)
 */

const TotalTable = ({ dataTotals = [], columns = [], grandTotalFields = [] }) => {
    if (!dataTotals || !Array.isArray(dataTotals) || dataTotals.length === 0) return null;

    // Find the grand total row (usually the last one)
    const grandTotalRow = dataTotals.find(row => Object.keys(row).some(k => k.includes('grand_total')));

    return (
        <Box>
            <TableContainer component={Paper} sx={{ height: 'auto' }}>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {columns.map(col => (
                                <TableCell key={col.field} align={col.field === 'month' ? 'left' : 'center'}>
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataTotals.map((data, i) => {
                            // Skip grand total row in body
                            if (Object.keys(data).some(k => k.includes('grand_total'))) return null;
                            return (
                                <TableRow key={i}>
                                    {columns.map(col => (
                                        <TableCell key={col.field} align={col.field === 'month' ? 'left' : 'center'}>
                                            {data[col.field]}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            );
                        })}
                        {grandTotalRow && (
                            <TableRow sx={{ border: '2px solid black' }}>
                                {grandTotalFields.length > 0
                                    ? grandTotalFields.map((col, index) => (
                                        <TableCell key={index} align={col.label === 'Grand Total' ? 'left' : 'center'}>
                                            <b>{grandTotalRow[col.field] ? grandTotalRow[col.field] : (index === 0 ? 'Grand Total' : grandTotalRow[col.field] === 0 ? 0 : 'N/A')}</b>
                                        </TableCell>
                                    ))
                                    : columns.map((col, index) => (
                                        <TableCell key={index} align="left">
                                            <b>{index === 0 ? 'Grand Total' : grandTotalRow[col.field]}</b>
                                        </TableCell>
                                    ))}
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default TotalTable;